import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";

/*
CFAC-34719 2023 Data Layer
https://github.com/blake-sdi/client-cfa-dl-spec/tree/cfa-ecomm-update/events
*/1
export class DataLayerService extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
	}

	/*
	CFAC-34720 Accordion
	https://github.com/blake-sdi/client-cfa-dl-spec/tree/cfa-ecomm-update/events/accordion
	*/
	public static pushDataLayerEvent_Accordion(
		toggle: Element
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: toggle.getAttribute("data-layer-event"),
			eventModel: {
				identifier: toggle.getAttribute("data-layer-identifier"),
				name: toggle.getAttribute("data-layer-name"),
				heading: toggle.getAttribute("data-layer-heading"),
				index: toggle.getAttribute("data-layer-index"),
				type: toggle.getAttribute("data-layer-type")
			}
		});
	}

	/*
	CFAC-34723 Carousel
	https://github.com/blake-sdi/client-cfa-dl-spec/tree/cfa-ecomm-update/events/carousel
	*/
	public static pushDataLayerEvent_Carousel(
		sliderEl: JQuery,
		event: string,
		index: number,
		targetIndex: number | undefined,
		defaultName: string
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: event,
			eventModel: {
				eventModel: {
					identifier: sliderEl.attr("data-layer-identifier") || defaultName,
					name: sliderEl.attr("data-layer-name") || defaultName,
					index: index,
					target_index: targetIndex
				}
			}
		});
	}

	/*
	CFAC-34725 Forms
	https://github.com/blake-sdi/client-cfa-dl-spec/tree/cfa-ecomm-update/events/forms
	*/
	public static pushDataLayerEvent_Forms(
		event: string,
		eventModel: object
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: event,
			eventModel: eventModel
		});
	}

	/*
	CFAC-34726 Lists
	https://github.com/blake-sdi/client-cfa-dl-spec/tree/cfa-ecomm-update/events/lists
	*/
	public static pushDataLayerEvent_Lists_SelectContent(
		toggle: Element
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ eventModel: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: "select_content",
			eventModel: {
				content_type: toggle.getAttribute("data-layer-content-type"),
				identifier: toggle.getAttribute("data-layer-identifier"),
				index: toggle.getAttribute("data-layer-index"),
				list_type: toggle.getAttribute("data-layer-list-type"),
				name: toggle.getAttribute("data-layer-name")
			}
		});
	}

	public static pushDataLayerEvent_Lists_SelectItem(
		toggle: HTMLElement
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: "select_item",
			ecommerce: {
				item_list_id: toggle.getAttribute("data-layer-list-id"),
				item_list_name: toggle.getAttribute("data-layer-list-name"),
				list_type: toggle.getAttribute("data-layer-list-type"),
				index: toggle.getAttribute("data-layer-index")
			}
		});
	}

	public static pushDataLayerEvent_Lists_ViewItemList(
		toggle: Element
	): void {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null });  // Clear the previous eventModel object.
		window.dataLayer.push({
			event: "view_item_list",
			ecommerce: {
				item_list_id: toggle.getAttribute("data-layer-list-id"),
				item_list_name: toggle.getAttribute("data-layer-list-name"),
				list_type: toggle.getAttribute("data-layer-list-type")
			}
		});
	}
}

ComponentFactory.registerComponent("DataLayerService", DataLayerService);
